import React from "react";
import { motion } from "framer-motion";

const ProductComparisonTable = () => {
    return(
        <>
        <section className="product-comparison-section">
         <div className="container">
       
           {/* SUBHEADING */}
           <motion.h3
             className="section-subheading"
             initial={{
               opacity: 0,
               y: 20,
             }}
             whileInView={{
               opacity: 1,
               y: 0,
             }}
             transition={{
               duration: 0.5,
               ease: [0.22, 1, 0.36, 1],
             }}
             viewport={{
               once: true,
             }}
           >
             PRODUCT COMPARISON
           </motion.h3>
       
           {/* HEADING */}
           <motion.h2
             className="section-heading"
             initial={{
               opacity: 0,
               y: 30,
             }}
             whileInView={{
               opacity: 1,
               y: 0,
             }}
             transition={{
               delay: 0.12,
               duration: 0.7,
               ease: [0.22, 1, 0.36, 1],
             }}
             viewport={{
               once: true,
             }}
           >
             Compare Our Wooden Packaging Products
           </motion.h2>
       
           {/* TABLE */}
           <motion.div
             className="comparison-table-wrapper"
             initial={{
               opacity: 0,
               y: 35,
             }}
             whileInView={{
               opacity: 1,
               y: 0,
             }}
             transition={{
               delay: 0.25,
               duration: 0.7,
               ease: [0.22, 1, 0.36, 1],
             }}
             viewport={{
               once: true,
               amount: 0.1,
             }}
           >
       
             <table className="comparison-table">
       
               {/* HEADER */}
               <motion.thead
                 initial={{
                   opacity: 0,
                 }}
                 whileInView={{
                   opacity: 1,
                 }}
                 transition={{
                   delay: 0.35,
                   duration: 0.5,
                 }}
                 viewport={{
                   once: true,
                 }}
               >
                 <tr>
                   <th>Product</th>
                   <th>Product Overview</th>
                   <th>Best Used For</th>
                 </tr>
               </motion.thead>
       
               {/* BODY */}
               <tbody>
       
                 {[
                   {
                     name: "Euro Pallets",
                     overview:
                       "Standardized, export-grade pallets built for efficient handling.",
                     used:
                       "Warehousing, racking systems, export shipments.",
                   },
                   {
                     name: "Wooden Pallets",
                     overview:
                       "Strong and durable pallets for material handling and logistics.",
                     used:
                       "Industrial storage, load handling, transportation.",
                   },
                   {
                     name: "Wooden Boxes",
                     overview:
                       "Enclosed wooden packaging for protection and secure handling.",
                     used:
                       "Machinery, equipment, industrial goods, heavy materials.",
                   },
                   {
                     name: "Plywood Boxes",
                     overview:
                       "Plywood-based boxes offering strength with lightweight structure.",
                     used:
                       "Export packaging, electronics, precision equipment.",
                   },
                   {
                     name: "Wooden Crates",
                     overview:
                       "Heavy-duty crates for bulky, oversized, and sensitive items.",
                     used:
                       "Heavy machinery, large equipment, engineering products.",
                   },
                   {
                     name: "Customised Packaging",
                     overview:
                       "Tailor-made packaging designed as per product and application.",
                     used:
                       "Special requirements, unique shapes, industrial solutions.",
                   },
                 ].map((item, i) => (
       
                   <motion.tr
                     key={i}
                     initial={{
                       opacity: 0,
                       y: 20,
                     }}
                     whileInView={{
                       opacity: 1,
                       y: 0,
                     }}
                     transition={{
                       delay: 0.4 + i * 0.1,
                       duration: 0.5,
                       ease: [0.22, 1, 0.36, 1],
                     }}
                     viewport={{
                       once: true,
                       amount: 0.05,
                     }}
                   >
       
                     <td>
                       <div className="product-name">
                         <strong>{item.name}</strong>
                       </div>
                     </td>
       
                     <td>
                       {item.overview}
                     </td>
       
                     <td>
                       {item.used}
                     </td>
       
                   </motion.tr>
       
                 ))}
       
               </tbody>
       
             </table>
       
           </motion.div>
       
         </div>
       </section>
        </>
    )
}
export default ProductComparisonTable;